import React from 'react';
import NotificationBell from '../Notifications/NotificationBell';
import './PageHeader.css';

/**
 * Header persistente sopra il contenuto delle pagine
 * Non viene ricaricato al cambio pagina
 */
const PageHeader = ({ title, subtitle }) => {
  return (
    <div className="page-header">
      <div className="page-header-content">
        {/* Titolo e sottotitolo (opzionali) */}
        <div className="page-header-info">
          {title && <h1 className="page-title">{title}</h1>}
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>

        {/* Azioni header (campanella notifiche, etc) */}
        <div className="page-header-actions">
          {/* TODO: Riabilitare quando il sistema notifiche sarà completo */}
          {/* <NotificationBell /> */}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
